import React from "react";
import styles from "./Footer.module.scss";

declare global {
  interface Window {
    OneTrust: any;
  }
}

export const Footer = function () {
  return (
    <footer className={styles.footer}>
      <section className={styles.content}>
        <div className={styles.logo}>
          <img src="https://media.bootcampcdn.com/Columbia/logos/columbia_logo_wht.svg" alt="logo" />
        </div>
        <ul className={`${styles.links} legal-text`}>
          <li>
            This course is offered through Columbia Engineering:{" "}
            <a href="https://www.engineering.columbia.edu/" target="_blank">
              https://engineering.columbia.edu/
            </a>
          </li>
          <li>
            In partnership with{" "}
            <a href="https://www.edx.org/" target="_blank">
              <i>edX</i>
            </a>
          </li>
          <li>
            Contact Columbia Engineering Boot Campsat <a href="tel:6468701598">(646) 870-1598</a>
          </li>
          <li>
            <a href="https://bootcamp.cvn.columbia.edu/privacy-policy/" target="_blank">
              Privacy/Your Privacy Rights
            </a>{" "}
            |{" "}
            <a href="https://bootcamp.cvn.columbia.edu/terms/" target="_blank">
              Terms & Conditions
            </a>{" "}
            |{" "}
            <a href="https://bootcamp.cvn.columbia.edu/cookie-policy/" target="_blank">
              Cookie Policy
            </a>
          </li>
          <li>
            <a
              href=""
              target="_self"
              onClick={function (event) {
                event.preventDefault();

                if (typeof window.OneTrust === "undefined") {
                  console.error("Error: OneTrust is not defined");
                  return;
                }

                window.OneTrust.ToggleInfoDisplay();
              }}
            >
              Your Privacy Choices
            </a>
          </li>
        </ul>
      </section>
    </footer>
  );
};
